<template>
  <div>
    <v-tooltip
      v-for="(item, index) in $store.state.staffing.tooltip.tooltipAttachIdArr"
      :key="`tooltip_${index}`"
      :activator="`#${item}`"
      :color="tooltipMapping(item).color || 'primary'"
      open-delay="200"
      top
      v-bind="{ [tooltipMapping(item).position]: true }"
    >
      <span>{{ tooltipMapping(item).value || 'tooltip' }}</span>
    </v-tooltip>
  </div>
</template>

<script>

import { computed } from '@vue/composition-api'
import { store } from '@/myops/core'

export default {
  name: "TooltipMount",
  setup() {

    const tooltipMapping = (item) => {
      console.log(store.state.staffing.tooltip.tooltipMapping[item])
      return store.state.staffing.tooltip.tooltipMapping[item]
    }

    return {
      tooltipMapping
    }

  }
}
</script>

<style scoped>

.v-icon {
  transform: translateY(-1px);
}

</style>
